export const RESOLUTION = 1;
export const APP_WIDTH = 1080 * RESOLUTION;
export const APP_HEIGHT = 2330 * RESOLUTION;
export const CARD_HEIGHT = 280 * RESOLUTION;
export const CARD_WIDTH = 194 * RESOLUTION;
export const OUTLINE_WIDTH = 10 * RESOLUTION;
export const TEXT_SIZE = 72 * RESOLUTION;
export const MIDDLE_X_LOCATION = APP_WIDTH / 2;

export function redrawFullScreenOverlay(graphics, width, height) {
    graphics.clear();
    graphics.rect(-width / 2, -height / 2, width, height);
    graphics.fill({ color: '#000000' });
}
export const POWER_TEXT_SIZE = 50 * RESOLUTION;

export const getProxiedCardImageUrl = (imgUrl) => {
    const extractedImgNameAndExt = imgUrl.split('/').pop();
    return "/proxy/image/" + extractedImgNameAndExt;
};

export const convertToVec3 = (hexColor) => {
    const r = parseInt(hexColor.substr(1,2), 16);
    const g = parseInt(hexColor.substr(3,2), 16);
    const b = parseInt(hexColor.substr(5,2), 16);
    return [r / 255.0, g / 255.0, b / 255.0];
};

export const findCardContainer = (scene, cardInstanceId) => {
    if (!cardInstanceId) {
        return null;
    }

    const searchInContainer = (container) => {
        // Skip if not a container or no children
        if (!container.children || container.children.length === 0) {
            return null;
        }

        // Check each child
        for (const child of container.children) {
            // If this is a card container with matching ID, return it
            if (child?.cardInstance?.instanceId === cardInstanceId) {
                return child;
            }

            // Recursively search in child containers
            const found = searchInContainer(child);
            if (found) {
                return found;
            }
        }

        return null;
    };

    // Start search from the scene
    return searchInContainer(scene);
}